import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { getStaticPageContent } from '~/services/contentService'
import { usePlatformConfig } from '~/context/platform'
import { useLocalisation } from '~/context/localisation'
import { useNotification } from '~/context/notification'
import { useContentfulPreviewMode } from '~/hooks/useContentfulPreviewMode/useContentfulPreviewMode'
import { GenericClientError } from '~/utils/errors'

export const useStaticPageContent = (contentfulIdentifier: string) => {
  const { locale } = useLocalisation()
  const { opCo } = usePlatformConfig()
  const { addErrorCodeNotification } = useNotification()
  const preview = useContentfulPreviewMode()

  const { data, isLoading, error, isError } = useQuery({
    queryKey: ['staticPageContent', opCo, contentfulIdentifier, locale, preview],
    queryFn: () => getStaticPageContent(opCo, contentfulIdentifier, locale, preview),
  })

  useEffect(() => {
    if (isError && error instanceof GenericClientError) {
      addErrorCodeNotification('CONTENT_STATIC_PAGE_ERROR', {
        type: 'ERROR',
        errorCode: error.code,
        statusCode: error.httpStatus,
      })
    }
  }, [isError, error, addErrorCodeNotification])

  return {
    hero: data?.hero,
    content: data?.staticContent,
    thumbnail: data?.thumbnail,
    accordionCollection: data?.accordion,
    isLoading,
  }
}
